import { css, CSSResultGroup, html, LitElement } from 'lit'
import { customElement, property } from 'lit/decorators.js'
import { provide } from '@lit/context'
import { productTileIndexContext, productTileProductContext } from 'components/discovery/product/tile-parts/tile-product-context.js'
import { InternalProduct, ProductModel } from 'components/discovery/product/tile-parts/tile-parts-typing.js'

/** Minimal host that provides product context for standalone tile-part stories. */
@customElement('story-tile-part-host')
export class StoryTilePartHost extends LitElement {
  static override styles: CSSResultGroup = css`
    :host {
      display: block;
    }
  `

  @provide({ context: productTileProductContext })
  @property({
    type: Object,
    converter: (value): InternalProduct => {
      if (value) {
        const raw = typeof value === 'string' ? JSON.parse(value) : value as Record<string, unknown>
        return new ProductModel().with(raw).parseToInternal()
      }
      return new ProductModel().parseToInternal()
    },
  })
  product: InternalProduct = new ProductModel().parseToInternal()

  @provide({ context: productTileIndexContext })
  @property({ type: Number })
  index?: number

  override render() {
    return html`<slot></slot>`
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'story-tile-part-host': StoryTilePartHost
  }
}
